/** @jsx h */
import { h } from 'preact'

import ExternalLink from '../ExternalLink'
import Profile from './Profile'
import t from '../../../utils/translate'

const EvidenceSection = ({ label, description, url, eventLabel, issuer }) =>
  <section class='ModalCard-section ModalCard-section--ugc'>
    <h3 class='ModalCard-heading'>
      {t('proof_points.js.evidence.see_proof')}
    </h3>

    <p class='ModalCard-para ModalCard-para--type u-marginTop8'>{label}</p>

    <p class='ModalCard-para u-marginTop8'>{description}</p>

    <ExternalLink href={url} linkName='View evidence' className='u-marginTop8' analyticsContext={eventLabel}>
      {t('proof_points.js.evidence.view')}
    </ExternalLink>

    {issuer && <Profile profile={issuer} />}
  </section>

export default EvidenceSection
